import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

/**
 * LayoutService
 *
 * Coordinates the application-wide 8-stage responsive cascade:
 *   Stage 1: Sidebar narrows (to icons)
 *   Stage 2: Profile text disappears (avatar icon remains in header)
 *   Stage 3: Sidebar disappears completely into hamburger button
 *   Stage 4: Profile avatar icon completely disappears from header (into drawer)
 *   Stage 5: Header title becomes compact (e.g. "Ceny")
 *   Stage 6: Search collapses to round icon button
 *   Stage 7: Filters collapse to drawer toggle button
 *   Stage 8: Secondary action icons move into drawer toolbar
 */
@Injectable({ providedIn: 'root' })
export class LayoutService {
  private _stage = new BehaviorSubject<number>(0)
  readonly stage$ = this._stage.asObservable()

  get currentStage(): number {
    return this._stage.value
  }

  setStage(stage: number): void {
    if (this._stage.value !== stage) {
      this._stage.next(stage)
      if (typeof document !== 'undefined') {
        const body = document.body

        body.classList.toggle('fs-sidebar-collapsed', stage >= 1)
        body.classList.toggle('fs-profile-compact', stage >= 2)
        body.classList.toggle('fs-sidebar-mobile', stage >= 3)
        body.classList.toggle('fs-profile-hidden', stage >= 4)

        for (let i = 1; i <= 8; i++) {
          body.classList.toggle(`fs-global-stage-${i}`, stage >= i)
        }
      }
    }
  }
}
